'use strict';

const tracking  = require('dibs-tracking');
const {
    category  : trackingCategory,
    actions   : trackingActions,
    labels    : trackingLabels,
    ecommerce : trackingEcommerce
} = require('./introduction-trackingConfig');

const copy  = require('./introduction-copy.json');
const impressions = [{
    id       : trackingEcommerce.id,
    name     : trackingEcommerce.name,
    creative : trackingEcommerce.creative + copy.cta,
    position : 1
}];

const introductionTrackingActions = {
    /**
     * Tracking when user clicks on banner cta button
     */

    trackEcommerceClick(actionContext, payload, done) {
        tracking.trackEvent({
            category: trackingCategory.click,
            action: trackingActions.click,
            label: trackingLabels.click
        });

        tracking.trackEcommerce({
            type       : 'promoClick',
            promotions : impressions
        });

        done();
    },

    /**
     * Tracking Ecommerce promo impression when banner is presented on page
     */
    trackBannerEcommerce(actionContext, payload, done) {
        tracking.trackEcommerce({
            type       : 'promotionImpression',
            promotions : impressions
        });

        done();
    }

};

module.exports = introductionTrackingActions;



// WEBPACK FOOTER //
// ./assets/js/components/Introduction/introduction-trackingActions.es.js